module.exports = __webpack_public_path__ + "static/media/emojis_13.bbf79c83.svg";